import { includes } from "lodash";
import { Small } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import { DefaultTreeHeader } from "src/shared/TreeView/TreeView";

const CustomTreeHeader = ({
  node,
  onSelectGroup,
  targetGroupTypes,
  existingGroupIds,
  actionLabel = "Select",
  existingGroupLabel,
  ...others
}) => {
  const { group } = node;

  const nodeStatus = () => {
    let status = null;
    if (group && targetGroupTypes[group.type]) {
      if (includes(existingGroupIds, group.id)) {
        if (existingGroupLabel) {
          status = (
            <Small variant="secondary">
              <em>{existingGroupLabel}</em>
            </Small>
          );
        }
      } else {
        status = (
          <Small variant="primary">
            <em>{actionLabel}</em>
          </Small>
        );
      }
    }

    return status;
  };

  return (
    <DefaultTreeHeader
      node={node}
      {...others}
      nodeStatus={nodeStatus}
      onActivate={() => onSelectGroup(group, node)}
    />
  );
};

CustomTreeHeader.propTypes = {
  node: PropTypes.object,
  onSelectGroup: PropTypes.func,
  targetGroupTypes: PropTypes.object,
  actionLabel: PropTypes.string,
  existingGroupIds: PropTypes.array,
  existingGroupLabel: PropTypes.string,
};

export default CustomTreeHeader;
